import styled from 'styled-components';

import { theme } from '@notino/react-styleguide';

export const Container = styled.div`
  max-width: 64.75rem;
  margin: 0 auto;
`;

export const ProductsCount = styled.div`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.tertiary};
  margin-bottom: 0.5rem;
  margin-top: 0.75rem;
  padding-inline: 1rem;

  @media (min-width: ${theme.breakpoints.md}) {
    margin-bottom: 0.75rem;
    margin-top: 1.5rem;
  }
`;
